module.exports = __webpack_public_path__ + "img/xbc1.00c89ae3.png";